var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light-blue-alt px-3 pt-2 pb-2 mb-3 rounded"},[_c('h3',{staticClass:"m-0 d-flex"},[_c('div',{staticClass:"pt-1"},[_vm._t("icon")],2),_c('div',{staticClass:"mx-2"},[_vm._t("message")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }